// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.expiry-timer-wrapper {
  border: 1px solid #ddd;
  border-radius: 6px;
  padding: 20px;
  font-weight: 600;
}
.expiry-timer-wrapper p {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 19px;
  margin: 0;
}
.expiry-timer-wrapper p span {
  font-size: 22px;
  font-weight: 400;
  display: inline-block;
  color: #93288E;
  width: 90px;
}`, "",{"version":3,"sources":["webpack://./src/pages/PublicPaymentPage/components/ExpiryCountdown/style.scss"],"names":[],"mappings":"AAAA;EACI,sBAAA;EACA,kBAAA;EACA,aAAA;EACA,gBAAA;AACJ;AAAI;EACI,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,SAAA;AAER;AADQ;EACI,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,cAAA;EACA,WAAA;AAGZ","sourcesContent":[".expiry-timer-wrapper{\n    border: 1px solid #ddd;\n    border-radius: 6px;\n    padding: 20px;\n    font-weight: 600;\n    p{\n        display: flex;\n        align-items: center;\n        gap: 10px;\n        font-size: 19px;\n        margin: 0;\n        span{\n            font-size: 22px;\n            font-weight: 400;\n            display: inline-block;\n            color: #93288E;\n            width: 90px\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
